export enum Role {
  ROOT = 'ROOT',
  ADMIN = 'ADMIN',
  USER = 'USER',
}
